<template>
    <el-dialog
        :title="$tt('批量设置按钮属性')"
        :visible="isShowModal"
        width="500px"
        custom-class="batch-btn-attr-dialog"
        @close="hide"
        :destroy-on-close="true"
        :append-to-body="true"
    >
        <el-form ref="form" :model="formData" label-width="100px">
            <el-form-item v-for="item in allAttrs" :key="item.key" :label="$tt(item.label)">
                <template v-if="item.type === 'input'">
                    <el-input-number
                        v-if="item.inputType === 'number'"
                        :controls="false"
                        :min="item.min"
                        :precision="item.precision"
                        v-model.number="formData[item.key]"
                    />
                    <!-- textArea文本 -->
                    <el-input
                        v-else-if="item.inputType == 'textarea'"
                        v-model="formData[item.key]"
                        type="textarea"
                    />
                    <el-input v-else v-model="formData[item.key]"></el-input>
                </template>
                 <!-- 下拉选择框 -->
                <el-select
                    v-else-if="item.type === 'select'"
                    v-model="formData[item.key]"
                    :placeholder="$tt('请选择')"
                >
                    <el-option
                        v-for="o in item.options"
                        :key="o.id"
                        :label="o.text"
                        :value="o.id"
                    >
                    </el-option>
                </el-select>
                <!-- 颜色选择 -->
                <el-color-picker
                    v-else-if="item.type === 'colorSet'"
                    v-model="formData[item.key]"
                    @change="(val) => {
                        colorChange(val, item.key);
                    }"
                />
                <UploadArea
                    :src="formData[item.key]"
                    v-else-if="item.type === 'uploadImg'"
                    :handler="
                    () => {
                        showImagesResourceModal(item);
                    }
                    "
                    :deleteHandler="
                    () => {
                        resetImageDefaultSrc(item);
                    }
                    "
                />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="hide">{{ $tt("取 消") }}</el-button>
            <el-button type="primary" @click="confirm">{{ $tt("确 定") }}</el-button>
        </span>
        <!-- 图片资源的modal -->
        <ImagesResourceModal
            ref="imagesResourceModal"
            modalOperationKey="other"
            :confirm="setImgConfirm"
        />
    </el-dialog>
</template>
<script>
import { fontFamilyOptions } from '@/utils/attrNameData';
import UploadArea from "@/components/UploadArea";
import ImagesResourceModal from "@/components/ImagesResourceModal";
import { isEmpty } from '@/utils/utils';

export default {
    data() {
        return {
            isShowModal: false,
            allAttrs: [
                { label: "按钮名称", key: "propValue", type: 'input', inputType: 'textarea' },
                { label: "按压名称", key: "btnPressName", type: 'input' },
                { label: "别名", key: "alias", type: 'input' },
                { label: "字体颜色", key: "color", type: 'colorSet' },
                { label: "背景图", key: "backgroundImage", type: 'uploadImg' },
                { label: "背景颜色", key: "backgroundColor", type: 'colorSet' },
                { label: "按压背景图", key: "pressBackgroundImage", type: 'uploadImg' },
                { label: "按压背景颜色", key: "pressBackgroundColor", type: 'colorSet' },
                { label: "字体", key: "fontFamily", type: 'select', options: fontFamilyOptions },
                { label: "字体大小", key: "fontSize", type: 'input', min: 0, precision: 0, inputType: 'number' }
            ],
            formData: this.initForm(),
            selectImgItem: null,
            // 下面几组key以数组索引对应，去找对应的键值
            imgKeyArr: ['backgroundImage', 'pressBackgroundImage'],
            imgColorArr: ['backgroundColor', 'pressBackgroundColor'],
            imgInfoArr: ['backgroundInfo', 'pressBackgroundImageInfo'],
            imgTypeArr: ['backgroundType', 'pressBackgroundType'],
            imgColorMap: {
                backgroundImage: 'backgroundColor',
                pressBackgroundImage: 'pressBackgroundColor'
            },
            retainColorKeys: [],
            // 颜色更换的字段
            colorChangeKeys: []
        };
    },
    components: {
        UploadArea,
        ImagesResourceModal
    },
    methods: {
        initForm() {
            return {
                propValue: '',
                btnPressName: '',
                alias: '',
                color: '',
                backgroundImage: '',
                backgroundColor: '',
                backgroundInfo: null,
                backgroundType: '',
                pressBackgroundImage: '',
                pressBackgroundColor: '',
                pressBackgroundImageInfo: null,
                pressBackgroundType: '',
                fontFamily: '',
                fontSize: undefined
            }
        },
        show() {
            this.retainColorKeys = [];
            this.colorChangeKeys = [];
            this.formData = this.initForm();
            this.isShowModal = true;
        },
        hide() {
            this.isShowModal = false;
        },
        confirm() {
            let params = {
                style: {
                    ...this.formData
                }
            };
            delete params.style.propValue;
            if (!isEmpty(this.formData.propValue)) {
                params.propValue = this.formData.propValue;
            }
            Object.keys(params.style).map((key) => {
                if (this.retainColorKeys.indexOf(key) !== -1) {
                    params.style[key] = '';
                } else if (this.imgColorMap[key] && params.style[this.imgColorMap[key]]) {
                    params.style[key] = '';
                } else if (this.imgInfoArr.includes(key)) {
                    // 如果对应的图片没有值，但是颜色有值，需要将对应的info值置为null
                    let keyInd = this.imgInfoArr.indexOf(key);
                    let colorVal = params.style[this.imgColorArr[keyInd]];
                    let imgVal = params.style[this.imgKeyArr[keyInd]];
                    if (!imgVal && colorVal) {
                        // 如果对应的图片没有值，但是颜色有值，需要将对应的info值置为null
                        params.style[key] = null
                    } else if (!imgVal) {
                        // 如果对应的图片没有值，但是颜色没有值，直接删除字段
                        delete params.style[key];
                    }
                    // 其他情况不处理，保留值即可
                } else if (isEmpty(params.style[key])) {
                    delete params.style[key];
                }
            });
            if (Object.keys(params.style).length === 0) {
                delete params.style;
            }
            console.log('confirm-----', params);
            this.$emit('confirm', params);
            this.hide();
        },
        showImagesResourceModal(item) {
            this.selectImgItem = item;
            this.$refs.imagesResourceModal.switchDialogVisible(true);
        },
        resetImageDefaultSrc(item) {
            this.formData[item.key] = '';
            let colorKey = this.imgColorMap[this.selectImgItem.key];
            if (colorKey) {
                this.retainColorKeys.splice(this.retainColorKeys.indexOf(colorKey), 1);
            }
        },
        setImgConfirm(src, info) {
            this.formData[this.selectImgItem.key] = `url(${src})`;
            let keyInd = this.imgKeyArr.indexOf(this.selectImgItem.key);
            if (keyInd !== -1) {
                // 说明是背景图、或者按压背景图，需要更新对应相关的键值
                // 由于设置了背景图片时候，应该把对应的背景颜色设置为''，所以需要手动清空下
                let colorKey = this.imgColorArr[keyInd];
                this.formData[colorKey] = '';
                this.retainColorKeys.push(colorKey);

                let typeKey = this.imgTypeArr[keyInd];
                this.formData[typeKey] = 'icon';
                // 需要更新对应的info
                let infoKey = this.imgInfoArr[keyInd];
                this.formData[infoKey] = info;
            }
            this.$refs.imagesResourceModal.switchDialogVisible(false);
        },
        colorChange(val, key) {
            let keyInd = this.imgColorArr.indexOf(key);
            if (keyInd !== -1) {
                if (!val) {
                    this.colorChangeKeys.splice(this.colorChangeKeys.indexOf(key), 1);
                    return;
                }
                let typeKey = this.imgTypeArr[keyInd];
                this.formData[typeKey] = 'color';
    
                let imgKey = this.imgKeyArr[keyInd];
                this.formData[imgKey] = '';

                let infoKey = this.imgInfoArr[keyInd];
                this.formData[infoKey] = null;
                this.colorChangeKeys.push(key);
                console.log('colorChange-----', this.formData);
            }
        }
    }
}
</script>
<style lang="scss">
.batch-btn-attr-dialog {
    .el-dialog__body {
        max-height: 52vh;
        overflow: auto;
        padding: 12px 20px;
    }
    .el-form-item {
        margin-bottom: 12px;
    }
    .el-form-item__label {
        color: #909399;
        font-size: 12px;
    }
    .el-input-number .el-input__inner {
        text-align: left;
    }
}
</style>
